(() => {
  const init = () => {
    if (window.innerWidth > 749 || document.body.dataset.oeConversionV2 === 'true') return;
    document.body.dataset.oeConversionV2 = 'true';

    const productRoot = document.querySelector('.template-product .fl-product');
    if (!productRoot) return;

    const isDigital = !!document.querySelector('.oe-product-promo');
    if (isDigital) document.body.classList.add('oe-product-digital');

    if (isDigital) {
      const grid = productRoot.querySelector('.fl-product__grid');
      const info = productRoot.querySelector('.fl-product__info');
      const gallery = productRoot.querySelector('.fl-product__gallery');
      if (grid && info && gallery && info.nextElementSibling !== gallery) grid.insertBefore(info, gallery);

      const help = {
        'Tracker seul': 'Budget, revenus et dépenses pour démarrer simplement.',
        'Pack complet': '8 outils + guide 30 jours. Le meilleur équilibre.',
        'Premium': 'Tout le Pack + PDF A5 + mises à jour à vie.'
      };
      productRoot.querySelectorAll('.fl-product__value').forEach(label => {
        const name = label.childNodes[0]?.textContent?.trim() || label.textContent.trim();
        const key = Object.keys(help).find(k => name.includes(k));
        if (!key || label.querySelector('.oe-variant-help')) return;
        const small = document.createElement('span');
        small.className = 'oe-variant-help';
        small.textContent = help[key];
        label.appendChild(small);
      });
    }

    const nativeButton = productRoot.querySelector('[data-add-button]');
    const price = productRoot.querySelector('[data-price]');
    const title = productRoot.querySelector('.fl-product__title');
    if (!nativeButton || !price) return;

    const sticky = document.createElement('div');
    sticky.className = 'oe-mobile-sticky-buy';
    sticky.innerHTML = `<div class="oe-mobile-sticky-buy__copy"><span>${isDigital ? 'Formule sélectionnée' : 'Prêt à commander'}</span><strong data-oe-sticky-price></strong></div><button type="button">${isDigital ? 'Ajouter au panier' : 'Ajouter'}</button>`;
    document.body.appendChild(sticky);

    const stickyPrice = sticky.querySelector('[data-oe-sticky-price]');
    const sync = () => {
      stickyPrice.textContent = `${title ? title.textContent.trim().replace('Pack Objectif Économies — Budget Excel & Google Sheets','Objectif Économies') : ''} · ${price.textContent.trim()}`;
    };
    sync();
    new MutationObserver(sync).observe(price, { childList: true, subtree: true, characterData: true });

    sticky.querySelector('button').addEventListener('click', () => nativeButton.click());

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { threshold: .15 });
      observer.observe(nativeButton);
    } else {
      sticky.classList.add('is-visible');
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
